import React from "react";

const LogoAnimation: React.FC = () => {
  return (
    <div className="flex justify-center items-center">
      <style>
        {`
          @keyframes bounceLogo {
            0% { transform: translateY(0); }
            50% { transform: translateY(-15px); }
            100% { transform: translateY(0); }
          }
          .logo-svg {
            width: 80px;
            animation: bounceLogo 1.5s ease-in-out infinite;
          }
          .logo-path {
            fill: #1f0570;
          }
        `}
      </style>
      <svg
        viewBox="0 0 134.23 202.14"
        className="logo-svg"
      >
        <path
          className="logo-path"
          d="M117.46,47.28c-1.53-2.13-3.27-4.19-5.22-6.12l-.04-2.58,22.03-7.56L85.74,0l-51.69,25.04,21.94,9.07.06.58c-4.38,3.22-8.02,7.22-10.81,11.91L3.65,116.46c-3.52,5.93-4.53,12.85-2.86,19.54,1.7,6.68,5.89,12.29,11.8,15.79,3.98,2.39,8.53,3.65,13.15,3.65,2.19,0,4.34-.28,6.38-.8,6.66-1.7,12.29-5.89,15.82-11.8l27.38-45.99-7.31-4.36-27.4,45.99c-2.34,3.96-6.1,6.77-10.57,7.91-4.49,1.14-9.13.45-13.09-1.91-3.95-2.36-6.77-6.13-7.89-10.59-1.14-4.47-.45-9.11,1.89-13.07L52.58,50.95c9-15.11,28.6-20.07,43.88-10.98,5.59,2.97,10.44,7.22,14.08,12.27,1.4,1.93,2.62,4.04,3.67,6.25-5.93.09-11.43,1.76-16.03,4.9-2.77,1.87-5.16,4.23-7.13,7.01-.73-.56-1.53-1.1-2.41-1.63-5.93-3.52-12.85-4.53-19.54-2.86-6.68,1.7-12.29,5.89-15.82,11.8l-29.49,49.49,7.33,4.36,29.49-49.49c2.34-3.95,6.1-6.77,10.57-7.89,4.47-1.14,9.11-.47,13.07,1.89,3.98,2.36,6.77,6.12,7.91,10.59,1.12,4.47.45,9.11-1.91,13.07l-47.88,80.38-5.35-21.15-8.25,2.08,10.4,41.09,58.41-98.04c3.52-5.91,4.53-12.85,2.84-19.51-.69-2.79-1.83-5.39-3.4-7.76,1.55-2.6,3.55-4.75,5.95-6.38,6.58-4.49,13.88-3.52,16.72-2.9l7.01,1.5-2.02-6.86c-1.55-5.37-3.98-10.4-7.22-14.91ZM103.6,32.52l.02,1.76c-.99-.62-2.02-1.23-3.03-1.76-6.32-3.74-13.41-5.63-20.57-5.63-5.39,0-10.81,1.07-15.92,3.27l-.26-2.02-8.96-3.7,30.28-14.68,29.61,18.93-11.18,3.82Z"
        />
      </svg>
    </div>
  );
};

export default LogoAnimation;
